import { getComMenus, getComMenusNonExportedCustomer } from './comMenus';
import { getDeuMenus, getDeuMenusNonExportedCustomer } from './deMenus';
import { getEsMenus, getEsMenusNonExportedCustomer } from './esMenus';
import { getFrMenus, getFrMenusNonExportedCustomer } from './frMenus';
import { getGbrMenus, getGbrMenusNonExportedCustomer } from './gbrMenus';
import { getIrlMenus, getIrlMenusNonExportedCustomer } from './irlMenus';
import { getNldMenus, getNldMenusNonExportedCustomer } from './nlMenus';
import { getPolMenus, getPolMenusNonExportedCustomer } from './plMenus';
import { getFinMenus, getFinMenusNonExportedCustomer } from './fiMenus';
export const getCustomerMenus = ({ menuProps: { menuLinks, customer, shouldShowPaymentMethodScreens }, locale = '', }) => {
    var _a;
    if (!customer)
        return getComMenus({ menuLinks, customer });
    const navItemsByCountries = {
        'de-DE': getDeuMenus({
            menuLinks,
            customer,
            shouldShowPaymentMethodScreens,
            shouldShowTaxExemptionScreen: true,
        }),
        'de-AT': getDeuMenus({ menuLinks, customer }),
        'en-GB': getGbrMenus({ menuLinks, customer }),
        'fr-FR': getFrMenus({ menuLinks, customer }),
        'es-ES': getEsMenus({ menuLinks, customer }),
        'nl-NL': getNldMenus({ menuLinks, customer }),
        'en-IE': getIrlMenus({ menuLinks, customer }),
        'pl-PL': getPolMenus({ menuLinks, customer }),
        'fi-FI': getFinMenus({ menuLinks, customer }),
    };
    return (_a = navItemsByCountries[locale]) !== null && _a !== void 0 ? _a : getComMenus({ menuLinks, customer });
};
export const getNonExportedCustomerMenus = (customer, menuLinks, locale = '') => {
    var _a;
    if (!customer)
        return getComMenusNonExportedCustomer(menuLinks);
    const nonExportedMenusByCountries = {
        'de-DE': getDeuMenusNonExportedCustomer(menuLinks),
        'de-AT': getDeuMenusNonExportedCustomer(menuLinks),
        'en-GB': getGbrMenusNonExportedCustomer(menuLinks),
        'fr-FR': getFrMenusNonExportedCustomer(menuLinks),
        'es-ES': getEsMenusNonExportedCustomer(menuLinks),
        'nl-NL': getNldMenusNonExportedCustomer(menuLinks),
        'en-IE': getIrlMenusNonExportedCustomer(menuLinks),
        'pl-PL': getPolMenusNonExportedCustomer(menuLinks),
        'fi-FI': getFinMenusNonExportedCustomer(menuLinks),
    };
    return (_a = nonExportedMenusByCountries[locale]) !== null && _a !== void 0 ? _a : getComMenusNonExportedCustomer(menuLinks);
};
//# sourceMappingURL=index.js.map